import { Button } from "components/DesignSystem/Button/Button";
import { NotePencil } from "components/icons/NotePencil";
import { UnifyNotes } from "components/Notes/UnifyNotes";
import { NOTE_TYPE } from "constants/unifyNotes";
import { useModal } from "hooks/useModal";
import { ChatTicket } from "types/Models/chatTicket";

export const TicketNotes = ({
  rowData,
  currentNoteLabel,
  allNotesCount,
  noteTrigger,
}: {
  rowData: ChatTicket;
  currentNoteLabel: string;
  allNotesCount?: number;
  noteTrigger?: React.ReactNode;
}) => {
  const notesModal = useModal();
  const entityId = rowData.entity?.uuid || "";
  const ticketId = rowData.uuid;
  const groupId = rowData.company_group?.uuid || "";

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        customType="ghost"
        onClick={(e) => {
          e.stopPropagation();
          notesModal.open();
        }}
      >
        {noteTrigger || (
          <div className="t-flex t-gap-1 t-items-center">
            <NotePencil />

            {typeof allNotesCount === "number" && allNotesCount > 0 && (
              <span className="t-text-subtext t-text-text-60">
                {allNotesCount}
              </span>
            )}
          </div>
        )}
      </Button>
      {notesModal.isOpen && (
        <UnifyNotes
          isOpen={notesModal.isOpen}
          close={notesModal.close}
          groupId={groupId}
          currentNoteLabel={currentNoteLabel}
          currentNoteType={NOTE_TYPE.TICKETS}
          currentNoteTypeId={ticketId}
          entityId={entityId}
          ticketAssignees={rowData.assignee}
          ticketResolved={rowData.resolved}
        />
      )}
    </div>
  );
};
